import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import PerksCard from '../PerksCard';
import { CardsContainer, PerksContainer, PerksContainerTitle } from './subcomponents';
import PerksCarousel from '../PerksCarousel';
var Perks = function (_a) {
    var clientId = _a.clientId, perks = _a.perks;
    var t = useTranslation().t;
    var isLessThanDesktop = useWindowSize().isLessThanDesktop;
    return (_jsxs(PerksContainer, { children: [_jsx(PerksContainerTitle, { children: t("".concat(clientId, ".perks.perksHeader")) }), isLessThanDesktop ? (_jsx(PerksCarousel, { perks: perks, clientId: clientId })) : (_jsx(CardsContainer, { children: perks.map(function (_a) {
                    var icon = _a.icon, titleTranslationKey = _a.titleTranslationKey, descriptionTranslationKey = _a.descriptionTranslationKey;
                    return (_jsx(PerksCard, { title: t("".concat(clientId, ".perks.").concat(titleTranslationKey)), description: t("".concat(clientId, ".perks.").concat(descriptionTranslationKey)), icon: icon }, titleTranslationKey));
                }) }))] }));
};
export default Perks;
